import type { WorkspaceItem } from '@/hooks/useWorkspace';
import {
  ClipboardIcon,
  FileAudio,
  FileImage,
  FilePen,
  FileText,
  FileVideo,
  FolderIcon,
  FolderOpen,
  Globe,
  type LucideIcon,
  MessagesSquareIcon,
  Mic,
} from 'lucide-react';
import { match } from 'ts-pattern';

const ChatbotIcon = ({
  type,
  collapsed,
  fallback = null,
}: {
  type: WorkspaceItem['type'];
  collapsed?: boolean;
  fallback?: LucideIcon | null;
}) => {
  return match(type)
    .with('DOCUMENT', () => FileText)
    .with('GROUP', () => (collapsed ? FolderIcon : FolderOpen))
    .with('NOTE', () => FilePen)
    .with('WEBSITE', () => Globe)
    .with('IMAGE', () => FileImage)
    .with('TEXT', () => ClipboardIcon)
    .with('VIDEO', () => FileVideo)
    .with('RECORDING', () => Mic)
    .with('AUDIO', () => FileAudio)
    .with('NOTHING', 'CHAT', () => MessagesSquareIcon)

    .otherwise(() => fallback);
};

export default ChatbotIcon;
